var React = require('react');

function Round1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#fff","strokeWidth":"1.5","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M75.26 8.92L61.505 1.29 1.5 35.71v68.85l14 7.66.48-68.67zM2.25 35.71l13.73 7.84"})));
}

Round1.defaultProps = {"viewBox":"0 0 123 140"};

module.exports = Round1;

Round1.default = Round1;
